import { File } from 'better-xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { ADMISSION_CONSENT_ITEMS, SIGNUP_CONSENT_ITEMS } from '../constans';
import { IAdmissionConsentListItem, ISignupConsentListItem } from '../models/consent.model';

const COLOR_HEADER_BG = 'BB0665';
const COLOR_WHITE = 'FFFFFFFF';
const ROW_HEIGHT_CM = 0.8;

const setHeaderStyle = (cell: any) => {
  cell.style.fill.patternType = 'solid';
  cell.style.fill.fgColor = COLOR_HEADER_BG;
  cell.style.fill.bgColor = COLOR_HEADER_BG;
  cell.style.font.color = COLOR_WHITE;
  cell.style.font.bold = true;
  cell.style.align.h = 'center';
  cell.style.align.v = 'center';
};

const setDataStyle = (cell: any) => {
  cell.style.align.h = 'center';
  cell.style.align.v = 'center';
};

const writeSheet = (sheet: any, headers: string[], rows: string[][]) => {
  const headerRow = sheet.addRow();
  headerRow.setHeightCM(ROW_HEIGHT_CM);
  headers.forEach((title) => {
    const cell = headerRow.addCell();
    cell.value = title;
    setHeaderStyle(cell);
  });

  rows.forEach((row) => {
    const dataRow = sheet.addRow();
    dataRow.setHeightCM(ROW_HEIGHT_CM);
    row.forEach((value) => {
      const cell = dataRow.addCell();
      cell.value = value;
      setDataStyle(cell);
    });
  });

  headers.forEach((_, index) => {
    sheet.col(index).width = 16;
  });
};

const SIGNUP_HEADERS = [
  '캠퍼스(귀속)',
  '학부모명',
  '자녀 수',
  ...SIGNUP_CONSENT_ITEMS.map((i) => i.label),
  '미동의 수(필수)',
  '최종 동의일시',
];

const toSignupRow = (item: ISignupConsentListItem): string[] => [
  item.attributedCampusNames,
  item.parentName,
  String(item.childCount),
  ...SIGNUP_CONSENT_ITEMS.map((def) => (item.signupItemAgreeYn[def.code] === 'Y' ? 'O' : 'X')),
  String(item.signupMissingCount),
  item.signupLastConsentDttm
    ? moment(item.signupLastConsentDttm).format('YYYY.MM.DD HH:mm')
    : '-',
];

/** 회원가입 동의(학부모 단위) 상세 목록 엑셀 다운로드 */
export const exportSignupConsent = (data: ISignupConsentListItem[]) => {
  if (!data.length) return;

  const file = new File();
  const sheet = file.addSheet('회원가입 동의 현황');
  writeSheet(sheet, SIGNUP_HEADERS, data.map(toSignupRow));

  const fileName = `CANB_회원가입동의현황_${moment().format('YYYYMMDD')}`;
  file.saveAs('blob').then((content: Blob) => {
    saveAs(content, `${fileName}.xlsx`);
  });
};

const ADMISSION_HEADERS = [
  '캠퍼스',
  '학부모명',
  '학생명',
  '학년',
  '수강반',
  '수강반상태',
  ...ADMISSION_CONSENT_ITEMS.map((i) => i.label),
  '미동의 수(필수)',
  '최종 동의일시',
  '학부모 회원가입 동의',
];

const toAdmissionRow = (item: IAdmissionConsentListItem): string[] => [
  item.campusName,
  item.parentName,
  item.studentName,
  item.gradeName,
  item.className,
  item.classStatusName,
  ...ADMISSION_CONSENT_ITEMS.map((def) =>
    item.admissionItemAgreeYn[def.code] === 'Y' ? 'O' : 'X',
  ),
  String(item.admissionMissingCount),
  item.admissionLastConsentDttm
    ? moment(item.admissionLastConsentDttm).format('YYYY.MM.DD HH:mm')
    : '-',
  item.parentSignupCompleteYn === 'Y' ? 'O' : 'X',
];

/** 입학동의(학생×캠퍼스 단위) 상세 목록 엑셀 다운로드 */
export const exportAdmissionConsent = (data: IAdmissionConsentListItem[]) => {
  if (!data.length) return;

  const file = new File();
  const sheet = file.addSheet('입학동의 현황');
  writeSheet(sheet, ADMISSION_HEADERS, data.map(toAdmissionRow));

  const fileName = `CANB_입학동의현황_${moment().format('YYYYMMDD')}`;
  file.saveAs('blob').then((content: Blob) => {
    saveAs(content, `${fileName}.xlsx`);
  });
};
